import {$, w} from './constants';
import { initYT } from'./youtube-lazy-load';

const MAIN = $('#MainContent');
const HEADER = $('#header_main');
const HEADER_MASK = $('.header__mask');
const HEADER_MENU = $('.header__menu');
const FOOTER_NAV = $('#footer_nav');

function calculateMaxSubmenuHeight(submenu) {
  let maxSubmenuHeight = 0;
  
  // Loop through each nested sub-menu
  submenu.find('.sub-menu').each(function() {
      let height = $(this).outerHeight();
      if (height > maxSubmenuHeight) {
          maxSubmenuHeight = height;
      }
  });
  
  return maxSubmenuHeight + submenu.outerHeight(); // Add the outer height of the direct submenu
}

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
    /*___ CONTACT F O R M ___*/
    $("#contact").validate({
      rules: {
          name : {
              required: true
          },
          email: {
              required: true,
              email: true
          },
          message: {
            required : true
          }
      },
      errorClass : "error-contact",
      errorElement: "span",
      submitHandler: function(form) {
          event.preventDefault();
          $('#submit').prop('disabled', true);
          $.ajax({
              url: cltvo_js_vars.ajax_url,
              type: form.method,
              data: $(form).serialize(),
              success: function(response) {
                  $('#name').val('');
                  $('#email').val('');
                  $('#message').val('');
                  $('#submit').prop('disabled', true);
                  $('#success').html('<span>Message sent!</span>')
              },
              error: function( error ){
                  $('#error').text( error.responseJSON.message );
              }
          });
      }
  });
  /*___/ END CONTACT F O R M ___*/
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');
    /* M E N U */
    $(window).on('scroll', function(){
      if( $(this).scrollTop() > 0 ){
        HEADER.addClass('active');
        if( HEADER_MASK.data('status') == 'open' && $(window).width() >= 1024 ) {
          HEADER_MASK.data('status', 'close');
          HEADER_MASK.attr('data-status', 'close');
          HEADER_MASK.css('height', `0`).removeClass('active');
          let active = HEADER.find('[data-status="open"]');
          active.data('status', 'close');
          active.attr('data-status', 'close');
          let prev_submenu = $(active).find('.sub-menu');
          prev_submenu.fadeOut(20);
          MAIN.removeClass('submenu-active');
        }
      }else{
        HEADER.removeClass('active');
      }
    })
    $('.parent_link').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      let active = HEADER.find('[data-status="open"]');
      let isSameTab = active.is($(this));
      let submenu = $(this).find('.sub-menu');

      if (active.length && !isSameTab) {
        let prev_submenu = $(active).find('.sub-menu');
        active.data('status', 'close');
        active.attr('data-status', 'close');
        prev_submenu.fadeOut(20);
        MAIN.removeClass('submenu-active');
      }
      
      if (isSameTab) {
        active.data('status', 'close');
        active.attr('data-status', 'close');
        HEADER_MASK.data('status', 'close');
        HEADER_MASK.attr('data-status', 'close');
        HEADER_MASK.css('height', `0`).removeClass('active');
        submenu.fadeOut(20);
        MAIN.removeClass('submenu-active');
      } else {
        active.data('status', 'close');
        active.attr('data-status', 'close');
        let prev_submenu = $(active).find('.sub-menu');
        prev_submenu.fadeOut(20);
        let submenuHeight = calculateMaxSubmenuHeight(submenu);
        MAIN.addClass('submenu-active');
        HEADER_MASK.data('status', 'open');
        HEADER_MASK.attr('data-status', 'open');
        HEADER_MASK.css('height', `${submenuHeight}px`).addClass('active');
        $(this).data('status', 'open');
        $(this).attr('data-status', 'open');
        submenu.delay(200).fadeIn(200);
        if( $(window).width() >= 1024){
          HEADER.addClass('active');
        }
      }
      
    })
    $('.parent_link .sub-menu').on('click', function(e){
      e.stopPropagation();
    })
    $('.btn--menu').on('click', function(){
      $(this).toggleClass('active');
      HEADER_MENU.fadeToggle(300).toggleClass('active');
    });
    MAIN.click(function(e){
      if( $(this).hasClass('submenu-active') ){
          e.preventDefault();
          e.stopPropagation();
          if( HEADER_MASK.data('status') == 'open' && $(window).width() >= 1024 ) {
            HEADER_MASK.data('status', 'close');
            HEADER_MASK.attr('data-status', 'close');
            HEADER_MASK.css('height', `0`).removeClass('active');
            let active = HEADER.find('[data-status="open"]');
            active.data('status', 'close');
            active.attr('data-status', 'close');
            let prev_submenu = $(active).find('.sub-menu');
            prev_submenu.fadeOut(20);
          }
      }
   })
    /* END M E N U */
    /* F O O T E R */
    if( $(window).width() <= 768 ){
      $('.parent_mobile').on('click', function(){
        let active = FOOTER_NAV.find('[data-status="open"]');
        let isSameTab = active.is($(this));
        let submenu = $(this).find('.sub-menu');
      
        if (active.length && !isSameTab) {
          let prev_submenu = $(active).find('.sub-menu');
          active.data('status', 'close');
          active.attr('data-status', 'close');
          active.removeClass('active');
          prev_submenu.slideUp(20);
        }
        
        if (isSameTab) {
          active.data('status', 'close');
          active.attr('data-status', 'close');
          active.removeClass('active');
          submenu.slideUp(20);
        } else {
          active.data('status', 'close');
          active.attr('data-status', 'close');
          let prev_submenu = $(active).find('.sub-menu');
          prev_submenu.slideUp(20);
          $(this).addClass('active');
          $(this).data('status', 'open');
          $(this).attr('data-status', 'open');
          submenu.slideDown(100);
        }
      });
    }
    /* END F O O T E R */
    /* HOME: H e r o */
    if( $('#slider_hero').length ){
        $('#slider_hero').slick({
            infinite: true,
            autoplay: false,
            speed: 400,
            slidesToShow: 1,
            adaptiveHeight: true,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: true,
            dotsClass: 'dots-home'
        })
    }
    /* END HOME: H e r o */
    /* HOME: P r i n c i p l e s */
    if ($('#slider_principles').length) {
      if ($(window).width() <= 1380) {
        $('#slider_principles').slick({
          infinite: false,
          autoplay: false,
          speed: 400,
          slidesToShow: 3,
          slidesToScroll: 3,
          variableWidth: true,
          arrows: true,
          prevArrow: "<div class='arrow arrow--left'>",
          nextArrow: "<div class='arrow arrow--right'>",
          responsive: [
            {
              breakpoint: 999,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 651,
              settings: {
                slidesToShow: 1,
                variableWidth: false,
                fade: true
              }
            }
          ]
        });
      }
    }
    
    /* END HOME: P r i n c i p l e s */

    if($('#yt-trigger')){
      initYT();
    }

    /* F A Q s */
    if($('#faqs_toggle').length){
      let lastItem;
      $('body').on('click', '.faq_question', function(){
          console.log('click')
          if($(this).parent().attr('data-state') === "open"){
              $(this).parent().data('state', 'close');
              $(this).parent().attr('data-state', 'close');
              $(this).siblings('.target_faq').slideUp('fast').removeClass('active');
          }else{
              lastItem = $('#faqs_toggle').find("[data-state = 'open']");
              $(lastItem).data('state', 'close');
              $(lastItem).attr('data-state', 'close');
              $(lastItem).children('.target_faq').slideUp('fast').removeClass('active');
              $(this).parent().data('state', 'open');
              $(this).parent().attr('data-state', 'open');
              $(this).siblings('.target_faq').slideToggle('slow').toggleClass('active');
          }
      });
  }
    /* END F A Q s */

    /* H E A D E R - A C T I V E */

      var parentLinks = $('.menu-item-has-children > a');
    
      parentLinks.each(function() {
        var subMenu = $(this).next('.sub-menu');
        if (subMenu.find('.current-menu-item, [aria-current="page"]').length > 0) {
          $(this).addClass('active');
        }
      });  
})



$('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .not('[href="#contact"]')
    .click(function(event) {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            if (target.length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 120
                }, 1000);
                
            }
        }
    });
$('a[href="#contact"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event){
      $('#contact_pop').fadeIn('400').addClass('active');
      // Obtiene el elemento de contenido interno
      let content = $('#contact_pop').find('.pop__container-inner');
      
      // Hace que el scroll se desplace al principio del contenido
      content.animate({ scrollTop: 0 }, 100);
  }
);

$('.btn_close_pop').on('click', function(){
  let target = $(this).data('pop');
  $(`.pop[data-pop="${target}"]`).fadeOut(200).removeClass('active');
  $('html, body').animate(
    {
      scrollTop: $(`.pop[data-pop="${target}"]`).offset().top - 120,
    },
    100
  );
});

$('.btn_list_text').on('click', function(){
  let obj = $(this).data('post');
  let key = $(this).data('more');
  let layout = $(this).data('global');
  $.ajax({
    type: 'POST',
    dataType: 'html',
    url: cltvo_js_vars.ajax_url,
    data: { action: 'pill', post_id: obj, key : key, layout: layout },
    success: function(data){
        $('#pill_pop_wrapper').html( data );
        $('#pill_pop').fadeIn('400').addClass('active');
        $('.btn_close_pop').on('click', function(){
          let target = $(this).data('pop');
          $(`.pop[data-pop="${target}"]`).fadeOut(200).removeClass('active');
          $('#pill_pop_wrapper').html( '' );
        }); 
        },
        error: function(errors){
            console.log( errors );
        }
     });
});
$('.btn_pop_people').on('click', function(){
  let obj = $(this).data('post');
  let key = $(this).data('more');
  let layout = $(this).data('global');
  $.ajax({
    type: 'POST',
    dataType: 'html',
    url: cltvo_js_vars.ajax_url,
    data: { action: 'people', post_id: obj, key : key, layout: layout },
    success: function(data){
        $('#people_pop_wrapper').html( data );
        $('#people_pop').fadeIn('400').addClass('active');
        $('.btn_close_pop').on('click', function(){
          let target = $(this).data('pop');
          $(`.pop[data-pop="${target}"]`).fadeOut(200).removeClass('active');
          $('#people_pop_wrapper').html( '' );
        }); 
        },
        error: function(errors){
            console.log( errors );
        }
     });
})

/* L I B R A R Y : Filter & Search */
let term_val = null;
let type_val = null;
let pager = 0;
let request = true;

const onAjaxDone = () => {
  if ($('#max_pages').val() == pager) {
    $('.library__grid-load').addClass('hide');
    request = false;
  } else {
    $('.library__grid-load').addClass('hide');
    $('.library__grid-load:last-child').removeClass('hide');
    request = true;
  }
};

const callResources = (size = 6, term = null, type = null, search = null) => {
  if (request) {
    request = false;
    if (type === 'all') {
      type = null;
    }
    if (term === 'all') {
      term = null;
    }

    const ajaxData = {
      action: search ? 'resources_search' : 'resources_filter',
      size: size,
      page: pager,
      term: term,
      type: type,
      search: search,
    };

    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: cltvo_js_vars.ajax_url,
      data: ajaxData,
      success: function (data) {
        pager += 1;
        if (pager === 1 || search) {
          $('#grid_resources').html(data);
          $('html, body').animate(
            {
              scrollTop: $('#grid_resources').offset().top - 120,
            },
            100
          );
        } else {
          $('#grid_resources').append(data);
        }
        onAjaxDone();

        $('.load_more').off('click').on('click', function () {
          callResources(size);
        });

        $('.load_more_filter').off('click').on('click', function () {
          term_val = $('select[name="themes"]').val();
          type_val = $('select[name="types"]').val();
          callResources(6, term_val, type_val);
        });
      },
      error: function (errors) {
        console.log(errors);
        request = true;
      },
    });
  }
};

const callSingle = (slug = null) => {
  $.ajax({
    type: 'POST',
    dataType: 'html',
    url: cltvo_js_vars.ajax_url,
    data: { action : 'single_resource',  slug : slug },
    success: function (data) {
      $('#grid_resources').html(data);
      $('html, body').animate(
        {
          scrollTop: $('#grid_resources').offset().top - 120,
        },
        100
      );
    },
    error: function (errors) {
      console.log(errors);
      request = true;
    },
  });
};

if ($('#grid_resources').length) {
  /* const resourceSlug = getUrlParameter('resource');
  if( resourceSlug.length ){
    callSingle(resourceSlug);
  }else{
    callResources();
  } */

  callResources();

  $('.load_more').on('click', function () {
    callResources();
  });

  $('.load_more_filter').on('click', function () {
    term_val = $('select[name="themes"]').val();
    type_val = $('select[name="types"]').val();
    callResources(6, term_val, type_val);
  });
}

$('select[name="themes"], select[name="types"]').on('change', function () {
  pager = 0;
  request = true;
  term_val = $('select[name="themes"]').val();
  type_val = $('select[name="types"]').val();
  callResources(6, term_val, type_val);
});

$('.close-search-library').on('click', function () {
  pager = 0;
  request = true;
  let searchInput = $('.input--search');
  searchInput.val('');
  $(this).css('visibility', 'hidden');
  type_val = $('select[name="types"]').val();
  term_val = $('select[name="themes"]').val();
  if (type_val === 'all') {
    type_val = null;
  }
  if (term_val === 'all') {
    term_val = null;
  }
  callResources(6, term_val, type_val);
});

$('#library_form_search').on('submit', function (e) {
  e.preventDefault();
  let searchTerm = $(this).find('input[name="s"]').val();
  $('select[name="types"]').val('all');
  $('select[name="themes"]').val('all');
  pager = 0;
  request = true;

  callResources(6, null, null, searchTerm);
});

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/* END L I B R A R Y : Filter & Search */

 /* C L O S E : Search */
 $('.input--search').on('input', function() {
  toggleCloseButton();
});
function toggleCloseButton() {
  let searchInput = $('.input--search');
  let closeButton = $('.close-search-library');

  if (searchInput.val().trim() !== '') {
    closeButton.css('visibility', 'visible');
  } else {
    closeButton.css('visibility', 'hidden');
  }
}
/* END C L O S E : Search */



